// extracted by mini-css-extract-plugin
module.exports = {"accordion_section":"style_accordion_section__2Kco2","accordion_section__title":"style_accordion_section__title__39jOE"};